import type { VoiceAgentOption } from '../../client';
import type { ChatItemView } from '../../hooks/useTeamChatSocket';

export function voiceAgentIsAvailable(agent: VoiceAgentOption): boolean {
  return (
    agent.available &&
    Boolean(agent.profile) &&
    (agent.mode === 'realtime' || agent.mode === 'push_to_talk')
  );
}

/** Keep voice choices inside the durable agent membership of this chat. */
export function conversationVoiceAgents(
  allOptions: VoiceAgentOption[],
  items: ChatItemView[],
): VoiceAgentOption[] {
  const conversationAgentIds = new Set<number>();
  for (const item of items) {
    if (item.agentId != null) conversationAgentIds.add(item.agentId);
    for (const agentId of item.mentionedAgentIds ?? []) {
      conversationAgentIds.add(agentId);
    }
  }
  if (conversationAgentIds.size === 0) {
    return allOptions.filter(voiceAgentIsAvailable);
  }
  return allOptions.filter((agent) => conversationAgentIds.has(agent.agentId));
}
